import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth';

export const useNavigationItems = () => {
    const { t } = useTranslation();
    const { profile } = useAuth();

    const navItems = [
        { name: t('nav.dashboard'), path: '/', icon: 'dashboard' },
        { name: t('nav.saved_leads'), path: '/leads-salvos', icon: 'bookmark' },
        { name: t('nav.integrations'), path: '/integracoes', icon: 'integration_instructions' },
        { name: t('nav.ai'), path: '/ia', icon: 'smart_toy' },
    ];

    // Adicionar item Admin apenas para usuários com role 'admin'
    if (profile?.role === 'admin') {
        navItems.push({ name: 'Admin', path: '/admin', icon: 'admin_panel_settings' });
    }

    return navItems;
};
